import { Injectable } from '@angular/core';
import { CustomProduct } from '@product/const';
import { CustomPaginationModel } from '@shared/models';
import { facadeFactory } from '@spartacus/core';
import { WISHLIST_FEATURE_LAZY, WishlistEntry } from '@wishlist/const';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: WishlistService,
      feature: WISHLIST_FEATURE_LAZY,
      methods: [
        'hasEntry',
        'getEntryLoading',
        'addEntry',
        'removeEntry',
        'getEntriesCount',
        'loadEntries',
        'getEntries',
        'getEntriesLoading',
        'getEntriesError',
        'loadProductsByEntries',
        'getProductsByEntries',
        'getWishlist',
        'loadPage',
      ],
      async: true,
    }),
})
export abstract class WishlistService {
  abstract hasEntry(entry: WishlistEntry): Observable<boolean>;
  abstract getEntryLoading(entry: WishlistEntry): Observable<boolean>;
  abstract addEntry(entry: WishlistEntry): void;
  abstract removeEntry(entry: WishlistEntry): void;

  abstract getEntriesCount(): Observable<number>;
  abstract loadEntries(): void;
  abstract getEntries(): Observable<WishlistEntry[]>;
  abstract getEntriesLoading(): Observable<boolean>;
  abstract getEntriesError(): Observable<boolean>;

  abstract loadProductsByEntries(entries: WishlistEntry[]): void;
  abstract getProductsByEntries(entries: WishlistEntry[]): Observable<CustomProduct[]>;

  abstract getWishlist(): Observable<{ results: CustomProduct[]; pagination: CustomPaginationModel }>;
  abstract loadPage(
    page: number,
    entries: WishlistEntry[],
    onProductsLoaded?: (products: CustomProduct[], pageNum: number) => void,
  ): void;
}
